import { render, staticRenderFns } from "./product-autocomplete.vue?vue&type=template&id=59d56ffd"
import script from "./product-autocomplete.vue?vue&type=script&lang=js"
export * from "./product-autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/tmp/peamit-release.ykZ9nX/Mod.Web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59d56ffd')) {
      api.createRecord('59d56ffd', component.options)
    } else {
      api.reload('59d56ffd', component.options)
    }
    module.hot.accept("./product-autocomplete.vue?vue&type=template&id=59d56ffd", function () {
      api.rerender('59d56ffd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/js/components/product-autocomplete.vue"
export default component.exports